import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Icon from '../../Icon';
var IconDefault = /*#__PURE__*/React.createElement(Icon, {
  fontSize: 12,
  className: "jmti-ellopsis-h"
});
var IconHoverLeft = /*#__PURE__*/React.createElement(Icon, {
  fontSize: 12,
  className: "jmti-angle-double-left"
});
var IconHoverRight = /*#__PURE__*/React.createElement(Icon, {
  fontSize: 12,
  className: "jmti-angle-double-right"
});

var PageItem = /*#__PURE__*/function (_React$Component) {
  _inherits(PageItem, _React$Component);

  var _super = _createSuper(PageItem);

  function PageItem(props) {
    var _this;

    _classCallCheck(this, PageItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      var type = _this.props.type;

      _this.setState({
        content: type === 'front' ? IconHoverLeft : IconHoverRight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        content: IconDefault
      });
    });

    _this.state = {
      content: IconDefault
    };
    return _this;
  }

  _createClass(PageItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;
      var content = this.state.content;
      return /*#__PURE__*/React.createElement("li", {
        className: classNames('jmtd-pagination-item', className, {
          'jmtd-pagination-item-disabled': disabled
        }),
        onClick: onClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, content);
    }
  }]);

  return PageItem;
}(React.Component);

PageItem.propTypes = {
  className: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default PageItem;